import React, { useState } from "react";
import styles from "./Chatbot.module.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Bot_image } from "../../controller/image";

const Chatbot = ({ conversations, isOpen, setIsOpen }) => {
  // const [isOpen, setIsOpen] = useState(false);
  const [isMaximized, setIsMaximized] = useState(false);

  return (
    <div id="chatbot">
      {/* Chat Popup */}
      <div
        className={`${styles.popupBox} ${styles.chatPopup} ${
          isOpen ? styles.activeBox : ""
        } ${isMaximized ? styles.maximizedBox : ""}`}
      >
        <div className={styles.chatbotWrapper}>
          {/* ✅ Header */}
          <div className={styles.popupHeader}>
            {/* Left → Search / Info */}
            <div className={styles.headerLeft}>HolyBot</div>

            {/* Right → Title + Icon */}
            <div className={styles.headerRight}>
              {/* <span className={styles.botTitle}>HolyBot</span> */}
              <span
                className={styles.controlIcon}
                onClick={() => setIsMaximized(!isMaximized)}
              >
                {isMaximized ? (
                  <i className="fa fa-window-restore" title="Minimize"></i>
                ) : (
                  <i className="fa fa-window-maximize" title="Maximize"></i>
                )}
              </span>
              {/* ❌ Close Button */}
              <span
                className={styles.controlIcon}
                onClick={() => setIsOpen(false)}
                title="Close"
              >
                <i className="fa fa-window-close"></i>
              </span>
            </div>
          </div>

          {/* ✅ Chat Area */}
          <div className={styles.chatArea}>
            <div className={styles.userMsg}>
              <h6>Intelligent Spiritual Search: Your AI Guide</h6>
              <ul>
                <li>
                  Elevate your spiritual quest. Engage in informed discovery
                  with our AI-enabled Search Bar.
                </li>
                <li>
                  Initiate your search to gain immediate access to Refined
                  Temple Cards - a structured compilation of sacred sites.
                </li>
                <li>
                  Also, receive detailed, sacred wisdom articulated in
                  structured sentences by the HOLYBOT chatbot.
                </li>
                <li>
                  Let's begin your journey now to find divine knowledge and
                  connection in one sacred space.
                </li>
              </ul>
            </div>

            {conversations?.map((msg, index) =>
              msg.type === "user" ? (
                <div key={index} className={styles.botMsg}>
                  {msg.message}
                </div>
              ) : (
                <div key={index} className={styles.userMsg}>
                  <h6>{msg.heading}</h6>
                  <p>{msg.description}</p>
                  {msg.title && <p>{msg.title}</p>}
                  <ul>
                    {msg.list.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      {/* Floating Button */}
      <div
        className={`${styles.floatingLogo} ${isOpen ? styles.active : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div>
          <div
            style={{ backgroundImage: `url(${Bot_image})` }} // Apply background-image here
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Chatbot;
